import React, { useMemo } from "react";
import { Helmet } from "react-helmet-async";
import { Alert, Box, Container, Paper, Stack, Typography } from "@mui/material";
import { gradArray } from "../components/form/fields/inputFields";
import Loading from "../components/spinners/Loading";
import { useGetTenantTestingSettingsQuery } from "../features/tenants/tenantsApiSlice";

export default function TestingFeesPage() {
  const { data, isLoading, isError, error } =
    useGetTenantTestingSettingsQuery();

  const feeRows = useMemo(() => {
    const fees = data?.testingSettings?.fees || {};

    return gradArray
      .filter((grad) => grad.id !== 1)
      .map((grad) => {
        const key = String(grad.id);
        const amount = Number(fees?.[key]);
        return {
          key,
          label: grad.label,
          amount: Number.isFinite(amount) ? amount : 0,
        };
      });
  }, [data]);

  if (isLoading) return <Loading />;

  return (
    <>
      <Helmet>
        <title>Dashboard | Prüfungsgebühren</title>
      </Helmet>

      <Container maxWidth="md" sx={{ pb: 4 }}>
        <Stack spacing={2} sx={{ mb: 3 }}>
          <Typography variant="h4">Prüfungsgebühren</Typography>
          <Typography variant="body1" color="text.secondary">
            Hier sehen Sie die aktuell gültigen Prüfungsgebühren. Die Beträge
            gelten für die jeweilige nächste Gürtelprüfung und dienen als
            Orientierung für die Prüfungsvorbereitung.
          </Typography>
        </Stack>

        {isError && (
          <Alert severity="error" sx={{ mb: 2 }}>
            {error?.data?.message ||
              "Prüfungsgebühren konnten nicht geladen werden."}
          </Alert>
        )}

        <Paper variant="outlined" sx={{ p: 3 }}>
          <Stack spacing={1.25}>
            {feeRows.map((row) => (
              <Box
                key={row.key}
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  borderBottom: "1px solid",
                  borderColor: "divider",
                  py: 1,
                }}
              >
                <Typography variant="body1">{row.label}</Typography>
                <Typography variant="body1" fontWeight={700}>
                  {row.amount.toFixed(2)} €
                </Typography>
              </Box>
            ))}
          </Stack>

          <Typography
            variant="caption"
            color="text.secondary"
            sx={{ display: "block", mt: 2 }}
          >
            Hinweis: Änderungen werden von der Verwaltung gepflegt und hier
            automatisch angezeigt.
          </Typography>
        </Paper>
      </Container>
    </>
  );
}
